export enum TextToPayCompanySettings {
    Name = 1,
    AddressLine1 = 2,
    AddressLine2 = 3,
    AddressCity = 4,
    AddressState = 5,
    AddressZip = 6,
    Phone = 7,
    Email = 8,
    Website = 9
}
